import { Inject, Injectable, ElementRef } from '@angular/core';
import { fromEventPattern } from 'rxjs';
import { STRIPE_PUBLISHABLE_KEY, US_STRIPE_PUBLISHABLE_KEY, STRIPE_OPTIONS, STRIPE_STYLE_OPTIONS, StripeCard } from './stripe.types';

@Injectable()
export class StripeService {
	public stripe: Promise<stripe.Stripe>;

	constructor(@Inject(STRIPE_PUBLISHABLE_KEY) key,
		@Inject(STRIPE_OPTIONS) private options,
		@Inject(STRIPE_STYLE_OPTIONS) private styleOptions) {
		this.stripe = key.then(x => Stripe(x));
	}

	async getElements(): Promise<stripe.elements.Elements> {
		return (await this.stripe).elements(this.options);
	}

	async getCard(element: ElementRef): Promise<StripeCard> {
		const card = (await this.getElements()).create('card', this.styleOptions);

		card.mount(element.nativeElement);

		return {
			card,
			onChange: fromEventPattern<stripe.elements.ElementChangeResponse>((handler) => card.on('change', (error) => handler(error)), () => { }),
			createToken: (options) => this.stripe.then(x => x.createToken(card, options))
		};
	}
}
@Injectable()
export class USStripeService {
	public stripe: Promise<stripe.Stripe>;

	constructor(@Inject(US_STRIPE_PUBLISHABLE_KEY) key,
		@Inject(STRIPE_OPTIONS) private options,
		@Inject(STRIPE_STYLE_OPTIONS) private styleOptions) {
		this.stripe = key.then(x => Stripe(x));
	}

	async getElements(): Promise<stripe.elements.Elements> {
		return (await this.stripe).elements(this.options);
	}

	async getCard(element: ElementRef): Promise<StripeCard> {
		const card = (await this.getElements()).create('card', this.styleOptions);

		card.mount(element.nativeElement);

		return {
			card,
			onChange: fromEventPattern<stripe.elements.ElementChangeResponse>((handler) => card.on('change', (error) => handler(error)), () => { }),
			createToken: (options) => this.stripe.then(x => x.createToken(card, options))
		};
	}
}
